import { Settings } from '@ais-ui/websockets';

export const isFilterAppliedOnStartUp = (
  settings: Settings,
  filterId: string
): boolean => {
  return (
    settings?.['ribbonPlugin.settings']?.favorite_filters?.filters?.some(
      (favoriteFilterId: string) => favoriteFilterId === filterId
    ) ?? false
  );
};
